/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { AddRolePageService } from '../../../services';
import { logger as log } from '@common/logger';
import { StorageModule } from '@vlinder-web/storage-module-react';

const MODULE_NAME = 'profile.machines.states.signUpuser';

const getSrv = () => {
  return vappContainer.get<AddRolePageService>(AddRolePageService.displayName);
};

export const addRole = async (context: any, event: any) => {
  const currentState = 'SIGN_UP_USER';
  const method = 'resiterUser';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.signUpUser(event?.payload);
      console.log(`content in machine :`, content);
      if (content) {
        return resolve({
          key: 'SIGN_UP_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        console.log(MODULE_NAME, `${content} msg: ${msg}`);
        return reject({
          key: 'SIGN_UP_USER_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'SIGN_UP_USER_FAILED',
        value: err?.message,
      });
    }
  });
};
